export var vetApprovedVideoContent = {
    videos: [
        {
            // the enablejsapi=1 query param is required for pausing the videos when switching slides
            src: 'https://player.vimeo.com/video/1087236649',
            title: 'How Do Vet Nutritionists Develop Dog Food?',
        },
        {
            src: 'https://player.vimeo.com/video/1087237979',
            title: 'What Makes Nom Nom Dog Food Nutritionally Complete & Balanced?',
        },
        {
            src: 'https://player.vimeo.com/video/1087234413',
            title: 'What Does Nom Nom Mean By Gently Cooked?',
        },
    ],
    tickerText: 'Vet Approved',
    headline: 'How Our Experts Develop Your Dog’s Food',
    subheading: 'They’re picky so pups don’t have to be.',
};
